import { useEffect, useState } from "react";
import { connect } from "react-redux";
import '../components/contextMenu/styles.css';
import { Stack, CircularProgress, TextField, Button, Typography, Card, Breakpoint, CardContent} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { CONTENT_COLOR } from "../models/Constants";
import '../components/Home.css';
import useResponsive from "../hooks/useResponsive";
import { actionCreators, selectors } from "../store";
import FetchHelper from "./FetchHelper";
import * as Model from "../models/Index";
import { Path as RoutePath } from "./../path";

//#region Props
export type HomeProps = 
    ReturnType<typeof mapStateToProps> 
    & ReturnType<typeof mapDispatchToProps>
//#endregion

const GET_TEST = "GET_TEST"

export const Home = (props: HomeProps) => {
    //#region Fields
    const {
        userId,
        userName,
        isAuthorize,
        onGetTest,
        onGetTestWarning
    } = props;

    const {
       onShowMessage,
    } = props;

    const isDesktop = useResponsive({ query: 'up', key: 'lg' as Breakpoint });

    const [loadingFlag, setLoadingFlag] = useState(false);

    const navigate = useNavigate()

    useEffect(() => {
        const handleBeforeUnload = (event:any) => {
            event.preventDefault()
            event.returnValue = '';
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [navigate]);

    useEffect(() => {
        if(!isAuthorize)
        {
            navigate('/login')
        }
    }, [isAuthorize])

    const handleStartTest = () => {
        setLoadingFlag(true)
        onGetTest({
            userId:userId
        })
    }

    const handleGetTestSuccess = (data:any) => {
        setLoadingFlag(false)
        if(data.resultCode == 0)
        {
            if(data.data)
            {
                navigate(RoutePath.test,{state:{data:data.data.sort((a:any, b:any) => a.questionNo - b.questionNo), questionId: data.questionId}})
            }
            else
            {
                onGetTestWarning()
            }
        }
    }

    const handleGetTestError = (data:any) => {
        setLoadingFlag(false)
    }

	return (
        <>
        <div style={{display:"flex", minHeight:"100vh", flexDirection:"column"}}>
            {loadingFlag && (
                <div style={{ top: "0px", left: '0px', position: "fixed", zIndex: 1500, width: '100%', height: '100%', padding: '50vh 50% 50% 50%', background: '#00000030' }}>
                    <CircularProgress />
                </div>
            )}
            <Stack style={{ height: '100vh', background: '#F9FAFB'}} justifyContent={'flex-start'}>
                <Stack justifyContent="center" alignItems="center" mt={2}>
                    <Card sx={{ width: isDesktop ?"60%":"80%", boxShadow: 5, marginTop: 3 }}>
                        <CardContent>
                            <Typography sx={{color:CONTENT_COLOR, fontSize:30, fontWeight:"bold"}}>ストレス耐性テスト</Typography>
                            <Stack direction={"row"} sx={{alignItems:"center"}} spacing={1} marginTop={2} marginLeft={"5px"}>
                                <TextField  
                                    defaultValue={userName}
                                    sx={{
                                        '& .MuiInputBase-input': {
                                        height: '8px',
                                        textAlign:"center",
                                        },
                                        width:"30%",
                                        fontSize:16,
                                    }}
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                ></TextField>
                                <Typography fontSize={16}>様</Typography>
                            </Stack>
                            <Stack direction={"column"} sx={{border:"1px solid grey"}} marginTop={2} marginInline={"10px"} padding={"10px"} spacing={1}>
                                <Typography fontSize={16} fontWeight={"bold"}>
                                この検査の目的は、あなたの適性を知ることです。正しい答えはありません。
                                </Typography>
                                <Typography fontSize={16} fontWeight={"bold"}>
                                各質問について、あなたの普段の行動にあてはまるかどうかをありのままに回答してください。
                                </Typography>
                                
                                <Typography fontSize={16} paddingTop={2}>
                                スタートボタンをクリックすると質問文と回答欄が表示されます。質問は全てで100問あります。回答時間10分を目標に、質問１から順にすべての質問に回答してください。回答欄をまちがえたり、とばしたりしないよう注意してください。
                                </Typography>
                                <Typography fontSize={16} component="span">
                                    「あてはまる」もしくは「どちらかといえばあてはまる」と思った場合は「はい」を、「あてはまらない」もしくは「どちらかといえばあてはまらない」と思った場合には「いいえ」を選択してください。<Typography fontSize={16} component="span" fontWeight={'bold'}>どうしてもどちらかに決められない場合のみ「？」を選択してください。</Typography>深く考え込むと決められなくなることがあります。難しく考えず思いついたまま回答してください。
                                </Typography>
                                <Typography fontSize={16}>
                                回答が終わりましたら、提出ボタンをクリックしてください。
                                </Typography>
                            </Stack>
                            <Stack direction={"row"} justifyContent={"end"} marginTop={2} marginRight={"10px"}>
                                <Button variant="contained" onClick={handleStartTest}>スタート</Button>
                            </Stack>
                        </CardContent>
                    </Card>
                </Stack>
            </Stack>

            <FetchHelper
                fetchId={GET_TEST}
                onComplete={(success, data, error) =>{
                        success ? handleGetTestSuccess(data) : handleGetTestError(data)
                    }
                }
            />
        </div>  
        </>
    );
};

const mapStateToProps = (state: any) => {
    return {
        userId: state.app.user?.userId,
        userName: state.app.user?.userName,
        isAuthorize: selectors.isAuthorize(state),
    };
};
const mapDispatchToProps = (dispatch: any) => {
    return {
        onShowMessage: (message: Model.Message) => dispatch(actionCreators.showMessage(message)),
        onGetTest:(params:any) =>dispatch(actionCreators.fetch(GET_TEST,'/question/get-test','POST',params,false,true)),
        onGetTestWarning:()=>dispatch(actionCreators.showMessage({
            type: "warning",
            title: "適性テストを受ける",
            body: "テストデータはまだ利用できません",
        })),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(Home);
